<template>
    <PageSidebar>
        <template #sidebarTitle> {{ $t("coffee.menu.data") }} </template>
        <template #sidebarMain>
            <div class="p-6 space-y-5">
                <FormToggleSm
                    v-model="coffee.sendEmails"
                    :title="$t('coffee.data.send_emails')"
                    :help="$t('coffee.data.send_emails_help')"
                />
                <FormDivider />
                <FormInput
                    v-model="coffee.webhookUrl"
                    :title="$t('coffee.data.webhook_url')"
                    :help="$t('coffee.data.webhooks_help')"
                />
            </div>
        </template>
    </PageSidebar>
</template>

<script>
import { PageSidebar } from "@easy/ui/page-components";
import { mapState, mapActions } from "vuex";
import { FormToggleSm, FormDivider, FormInput } from "@easy/ui/forms";

export default {
    name: "SidebarData",
    components: {
        PageSidebar,
        FormToggleSm,
        FormDivider,
        FormInput,
    },
    computed: {
        ...mapState("coffee", ["coffee", "hasChanges"]),
    },

    methods: {
        ...mapActions("coffee/projects", ["saveSnapshot"]),
    },
};
</script>
